import * as Sentry from '@sentry/react';
import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { contextGraphsKey } from '@/hooks/queries/use-context-graphs';
import { deleteContextGraph } from '@/services/context-graphs/delete-context-graph';
import { useOrgStore } from '@/stores/org-store';

export const useDeleteContextGraph = (
  options?: Omit<UseMutationOptions<void, Error, string>, 'mutationFn'>,
) => {
  const queryClient = useQueryClient();
  const orgId = useOrgStore((state) => state.currentOrg?.orgid ?? null);

  return useMutation({
    ...options,
    mutationFn: deleteContextGraph,
    onSuccess: (data, graphId, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: contextGraphsKey(orgId) });
      options?.onSuccess?.(data, graphId, context, mutation);
    },
    onError: (error, graphId, context, mutation) => {
      Sentry.captureException(error, {
        extra: { context: 'delete-context-graph', graphId },
      });
      options?.onError?.(error, graphId, context, mutation);
    },
  });
};
